import { useContext } from "react";
import { NavLink } from "react-router-dom";

import { TOP_LEVEL_PAGES } from "../constants";
import { LoginContext } from "../../context/login-context";

import { CustomButton } from "../custom-button";
import ToggleProfile from "../toggle-profile/toggle-profile";
import Icon from "../icon/icon";

import css from "./menu.module.css";

export default function Menu({
	navOpen,
	setNavOpen,
	activePage,
	setActivePage,
	toggleShowUpload,
}) {
  const { state: userData } = useContext(LoginContext);

	const menu = (
		<ul className={css.menu}>
			{TOP_LEVEL_PAGES?.filter(p=> p.scope.includes(userData?.user_role)).map((page) => (
				<li key={page.path}>
					<NavLink
						to={page.path}
						className={({ isActive, isPending }) =>
							isPending ? "pending" : isActive ? "active" : ""
						}
						onClick={() => {
							setNavOpen(false);
							setActivePage(page.display);
						}}
					>
						{page.display}
					</NavLink>
				</li>
			))}
		</ul>
	);

	const uploadBtn = (
    <CustomButton
      label="Upload Invoice"
      onClick={toggleShowUpload}
      icon={<Icon icon="Upload" stroke="#fff" />}
    />
	);
  
  const toggleProfile = <ToggleProfile user={userData} />

	const navigation = (
		<nav className={`${css.nav} ${navOpen ? css.opened : ""}`}>
			{menu}
      {toggleProfile}
		</nav>
	);

	return (
    <>
      {navigation}
      
      {activePage === "Dashboard" && <>{uploadBtn}</>}

      {toggleProfile}
    </>
  );
}
